var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgrammableField(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Programmable_Field",
    "data-name": "Programmable Field",
    transform: "translate(0.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 88,
    cy: 88,
    r: 88,
    transform: "translate(-0.041)",
    fill: "rgba(214,233,255,0.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10631",
    "data-name": "Group 10631",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(-0.041)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "settings_applications_black_24dp",
    transform: "translate(50.958 51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M5,58.309H58.309V5H5Zm9.519-26.655a20.8,20.8,0,0,1,.152-2.209l-4.836-3.77a1.165,1.165,0,0,1-.267-1.485l4.569-7.882a1.164,1.164,0,0,1,1.409-.5L21.221,18.1a17.343,17.343,0,0,1,3.884-2.285l.838-6.054a1.181,1.181,0,0,1,1.142-.952h9.139a1.181,1.181,0,0,1,1.142.952l.838,6.054a16.16,16.16,0,0,1,3.846,2.247l5.674-2.285a1.164,1.164,0,0,1,1.409.5L53.7,24.153a1.173,1.173,0,0,1-.267,1.485L48.6,29.408a14.85,14.85,0,0,1,.152,2.247,20.8,20.8,0,0,1-.152,2.209l4.836,3.77a1.165,1.165,0,0,1,.267,1.485L49.132,47a1.164,1.164,0,0,1-1.409.5L42.05,45.21A16.945,16.945,0,0,1,38.2,47.457l-.838,6.054a1.179,1.179,0,0,1-1.142.99H27.085a1.181,1.181,0,0,1-1.142-.952l-.838-6.054a16.16,16.16,0,0,1-3.846-2.247l-5.674,2.285a1.164,1.164,0,0,1-1.409-.5L9.607,39.156a1.173,1.173,0,0,1,.267-1.485L14.71,33.9a14.908,14.908,0,0,1-.19-2.247Z",
    transform: "translate(5.616 5.616)",
    fill: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M15.223,44.771l4.569,7.882a1.164,1.164,0,0,0,1.409.5l5.674-2.285a16.16,16.16,0,0,0,3.846,2.247l.838,6.054a1.181,1.181,0,0,0,1.142.952h9.139a1.179,1.179,0,0,0,1.142-.99l.838-6.054a16.945,16.945,0,0,0,3.846-2.247l5.674,2.285a1.164,1.164,0,0,0,1.409-.5l4.569-7.882a1.173,1.173,0,0,0-.267-1.485l-4.836-3.77a14.355,14.355,0,0,0,.152-2.209,22.257,22.257,0,0,0-.152-2.247l4.836-3.77a1.165,1.165,0,0,0,.267-1.485l-4.569-7.882a1.164,1.164,0,0,0-1.409-.5l-5.674,2.285a16.16,16.16,0,0,0-3.846-2.247l-.838-6.054a1.181,1.181,0,0,0-1.142-.952H32.7a1.179,1.179,0,0,0-1.142.99l-.838,6.054a16.03,16.03,0,0,0-3.846,2.209L21.2,21.392a1.164,1.164,0,0,0-1.409.5l-4.569,7.882a1.173,1.173,0,0,0,.267,1.485l4.836,3.77a14.908,14.908,0,0,0-.19,2.247,22.259,22.259,0,0,0,.152,2.247l-4.836,3.77a1.165,1.165,0,0,0-.228,1.485ZM37.27,30.759a6.511,6.511,0,1,1-6.511,6.511A6.533,6.533,0,0,1,37.27,30.759ZM63.925,3H10.616A7.613,7.613,0,0,0,3,10.616V63.925a7.613,7.613,0,0,0,7.616,7.616H63.925a7.613,7.613,0,0,0,7.616-7.616V10.616A7.613,7.613,0,0,0,63.925,3Zm0,60.925H10.616V10.616H63.925Z",
    fill: "#12355f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammableField);
export default __webpack_public_path__ + "static/media/Programmable Field.26a845b0ea768e6da7da883f4b47141c.svg";
export { ForwardRef as ReactComponent };